module.exports = {["template-common-add-to-cart-wrap"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="add-to-cart-wrap">\n		<div class="add-to-cart-attributes"></div>\n		<div class="button-wrap">\n		<div class="add-to-cart-button">\n			<div class="button-icon"></div>\n			<input type="text" class="button-text" autocapitalize="off" autocorrect="off" autocomplete="off" spellcheck="false" readonly="readonly"/>\n		</div>\n		</div>\n		<div class="sizes-calculating-block"></div>\n	</div>\n';
}
return __p;
},}